<template>
    <div class="list-group-item log-add" style="border-radius: 8px; margin-bottom: 16px; border-color: transparent; padding:16px; border:2px dashed #bbb;">
        <div class="row">
            <div class="col-md-11" style="display:flex;">
                <datepicker
                    v-if="!selectedTypeIsMessage"
                    :format="'yyyy-MM-dd'"
                    v-model="form.contacted_at"
                    language="sv"
                    input-class="form-control"
                    :monday-first="true"
                    :disabled="disabledDates">
                </datepicker>
                <input type="time" style="width:110px; margin-left:10px;" class="form-control" v-model="form.contacted_time" @input="timeManuallySet = true" v-show="!selectedTypeIsMessage" />
                <div v-if="selectedTypeIsMessage">{{ todayFormatted }}</div>
            </div>
            <div class="col-md-10">
                <type-select v-model="form.type" :types="types"></type-select>
                <div class="text-danger" v-if="getError('type')" style="margin-top:4px;">{{ getError('type')[0] }}</div>

                <div style="padding-top:12px;" v-if="activeAddon">
                    <component :is="activeAddon" v-model="addonData" :clinic="clinic" :options="selectedType ? (selectedType.options || []) : []"></component>
                </div>

            </div>
            <div class="col-md-29">

                <VueTrix inputId="contact_log_comment" v-model="form.comment" placeholder="Kommentar" v-if="!selectedTypeIsMessage" />

                <div style="padding-bottom:10px;" v-if="selectedTypeIsMessage">
                    <label style="margin-right:8px;"><input type="checkbox" v-model="form.contact_by_sms" :disabled="!canSendSms" /> SMS</label>
                    <span class="badge badge-yellow" style="margin-right:12px;" v-if="!canSendSms">Mobilnr saknas.</span>
                    <label style="margin-right:8px;"><input type="checkbox" v-model="form.contact_by_email" :disabled="!canSendEmail" /> Mejl</label>
                    <span class="badge badge-yellow" v-if="!canSendEmail">E-post saknas.</span>
                </div>

                <div v-if="selectedTypeIsMessage && form.contact_by_email">
                    <div style="display:flex; justify-content:flex-end; margin-bottom: 8px;">
                        <a style="color:#666; font-weight:400; cursor:pointer;" @click="openEmailPreview">Visa hela mejlet</a>
                    </div>
                    <input type="text" class="form-control" v-model="form.email_subject" placeholder="Ämne" style="margin-bottom: 16px;" />
                    <VueTrix inputId="contact_log_email_message" v-model="form.email_message" placeholder="E-postmeddelande" />
                </div>

                <div style="width:100%; height: 20px;" v-if="form.contact_by_sms && form.contact_by_email"></div>

                <div v-if="selectedTypeIsMessage && form.contact_by_sms" style=" margin-top:10px;">
                    <textarea class="form-control" style="height: 250px;" v-model="form.sms_message" placeholder="SMS-meddelande"></textarea>
                </div>

            </div>
        </div>

        <div class="modal fade" tabindex="-1" role="dialog" id="emailPreviewModal">
            <div class="modal-dialog modal-lg" style="max-width: 900px;" role="document">
                <div class="modal-content" style="padding: 20px; border-radius: 12px;">
                    <iframe :srcdoc="emailPreviewHtml" style="width:100%; height:600px; border:none;"></iframe>
                </div>
            </div>
        </div>

        <div style="display: flex; justify-content: flex-end; padding-top:16px;">
            <div v-if="isLocal" style="margin-right:50px;">
                <button class="btn btn-xs btn-info" style="margin-right:6px;" @click="mockIncoming('sms')">Fejka inkommande SMS</button>
                <button class="btn btn-xs btn-info" @click="mockIncoming('email')">Fejka inkommande e-post</button>
            </div>
            <button class="btn btn-default btn-block" style="width:120px;" @click="posterPost()" :disabled="poster.submitted">
                <span v-if="selectedTypeIsMessage">Skicka</span>
                <span v-else>Lägg till</span>
            </button>
        </div>

    </div>
</template>

<script>

import axios from 'axios'
import poster from '../../../../shared/mixins/poster'
import TypeSelect from './create-type-select.vue'
import VueTrix from 'vue-trix'

import UppstartssamtalAddon from './addons/UppstartssamtalAddon.vue'
import TypeOptionsAddon from './addons/TypeOptionsAddon.vue'

export default {

    mixins: [
        poster
    ],

    components: {
        TypeSelect,
        VueTrix,
        UppstartssamtalAddon,
        TypeOptionsAddon,
    },

    props: {
        clinic: {
            required: true
        },
        types: {
            type: Object,
            default: () => ({})
        },
        contactLogs: {
            type: Array,
            default: () => []
        },
        prospectPortalBaseUrl: {
            type: String,
            default: ''
        },
        isLocal: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            user_name: user_name,
            user_phone: user_phone,
            addonData: {},
            emailPreviewHtml: '',
            selectedType: null,
            timeManuallySet: false,
            form: {
                contacted_at: new Date(),
                contacted_time: moment().format('HH:mm'),
                type: '',
                comment: '',
                sms_message: '',
                email_subject: '',
                email_message: '',
                contact_by_sms: false,
                contact_by_email: false,
            }
        }
    },

    created () {
        moment.locale('sv')
        this._timeSyncTimer = setInterval(this.syncTimeToNow, 1000)
    },

    beforeDestroy () {
        clearInterval(this._timeSyncTimer)
    },

    watch: {
        contactLogs: {
            immediate: true,
            handler () {
                if (!this.form.type) {
                    const defaults = this.defaultChannels
                    this.form.contact_by_sms = defaults.contact_by_sms
                    this.form.contact_by_email = defaults.contact_by_email
                }
            }
        },

        'form.type' (handle) {
            this.clearError('type')
            this.addonData = {}
            const group = Object.values(this.types).find(g => g.items.some(t => t.handle === handle))
            const match = group?.items.find(t => t.handle === handle)
            this.selectedType = match ?? null
            if (match) {
                this.form.sms_message   = this.formatMessage(match.default_sms_message)
                this.form.email_message = this.formatMessage(match.default_email_message)
                const lastEmailSubject  = this.contactLogs.find(l => l.contact_by_email && l.email_subject)?.email_subject ?? null
                this.form.email_subject = lastEmailSubject ?? (match.default_email_subject ?? '')
            }
        }
    },

    computed: {
        selectedTypeIsMessage () {
            const group = Object.values(this.types).find(g => g.items.some(t => t.handle === this.form.type))
            return group?.is_message ?? false
        },

        todayFormatted () {
            return moment().format('YYYY-MM-DD')
        },

        canSendSms () {
            return !!this.clinic.billing_phone
        },

        canSendEmail () {
            return !!this.clinic.email
        },

        defaultChannels () {
            const last = this.contactLogs.find(l => l.contact_by_sms || l.contact_by_email)
            if (last) {
                return {
                    contact_by_sms:   this.canSendSms  && last.contact_by_sms,
                    contact_by_email: this.canSendEmail && last.contact_by_email,
                }
            }
            return {
                contact_by_sms:   this.canSendSms,
                contact_by_email: false,
            }
        },

        disabledDates () {
            return {}
        },
        activeAddon () {
            const addonComponents = {
                'uppstartssamtal':        'uppstartssamtal-addon',
                'halsoresurs-tackat-nej': 'type-options-addon',
                'prospect-tackat-nej':    'type-options-addon',
                'slappt-prospect':        'type-options-addon',
            }
            return addonComponents[this.form.type] ?? null
        },
        posterUrl () {
            return '/clinics/' + this.clinic.id + '/contactLog'
        },
        posterData () {
            return {
                contacted_at: moment(this.form.contacted_at).format('YYYY-MM-DD') + ' ' + this.form.contacted_time + moment().format(':ss'),
                type: this.form.type,
                comment: this.form.comment,
                sms_message: this.form.sms_message,
                email_subject: this.form.email_subject,
                email_message: this.form.email_message,
                contact_by_sms: this.form.contact_by_sms,
                contact_by_email: this.form.contact_by_email,
                addon: this.addonData,
            }
        }
    },

    methods: {
        syncTimeToNow () {
            if (this.timeManuallySet) {
                return
            }
            const now = moment().format('HH:mm')
            if (now !== this.form.contacted_time) {
                this.form.contacted_time = now
            }
        },

        formatMessage (body) {
            if (!body) return ''
            const portalLink    = this.prospectPortalBaseUrl + '/' + this.clinic.card_token
            const prospectFname = (this.clinic.name_person || '').split(' ')[0]
            const adminFname    = (this.user_name || '').split(' ')[0]
            const adminFullname = this.user_name || ''
            const adminPhone    = this.user_phone || ''

            return body
                .replace(/\[prospect_portal_link\]/g, portalLink)
                .replace(/\[prospect-fname\]/g, prospectFname)
                .replace(/\[admin-fname\]/g, adminFname)
                .replace(/\[admin-fullname\]/g, adminFullname)
                .replace(/\[admin-phone\]/g, adminPhone)
        },

        mockIncoming (channel) {
            axios.post('/clinics/' + this.clinic.id + '/contactLog/mockIncoming', { channel })
                .then(response => {
                    this.$emit('created', response.data)
                    bus.$emit('notify', 'Mock inkommande ' + channel + ' skapad.')
                })
        },

        openEmailPreview () {
            axios.post('/clinics/' + this.clinic.id + '/contactLog/previewEmail', {
                email_subject: this.form.email_subject,
                email_message: this.form.email_message,
            }).then(response => {
                this.emailPreviewHtml = response.data
                this.$nextTick(() => {
                    $('#emailPreviewModal').modal('show')
                })
            })
        },

        posterSuccess (data) {
            this.form.contacted_at = new Date()
            this.form.contacted_time = moment().format('HH:mm')
            this.timeManuallySet = false
            this.form.type = ''
            this.form.comment = ''
            this.form.sms_message = ''
            this.form.email_subject = ''
            this.form.email_message = ''
            this.addonData = {}

            this.$emit('created', data)

            var message = 'Kontaktlogg sparades.';
            if(data.contact_by_sms && data.contact_by_email){
                message = 'Sms och mejl skickades';
            }else if(data.contact_by_sms){
                message = 'SMS skickades'; 
            }else if(data.contact_by_email){
                message = 'Mejl skickades';  
            }

            bus.$emit('notify', message)

            console.log(data)

        },
    }

}
</script>
